const lang = {
  state: {
    lang: ''
  },

  mutations: {
    SET_STORAGE: (state, value) => {
      state.lang = value
      window.localStorage.setItem('cloud_lang', value);
    },
    GET_STORAGE: (state) => {
      state.lang = window.localStorage.getItem('cloud_lang');
    },
    REMOVE_STORAGE: (state) => {
      window.localStorage.removeItem('cloud_lang');
      state.lang = ''
    }
  },

  actions: {
    
  }
}

export default lang



// WEBPACK FOOTER //
// ./src/store/modules/lang.js